import { avatarColor, initials } from "../utils/format";

interface Props {
  name: string;
  size?: number;
}

export function Avatar({ name, size = 32 }: Props) {
  return (
    <div
      className="ph-avatar"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.38,
        background: avatarColor(name),
      }}
    >
      {initials(name)}
    </div>
  );
}
